var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlertDismissable',{attrs:{"header":"Error","variant":"danger","icon":"exclamation-triangle","message":_vm.message},on:{"dismissed":function($event){return _vm.$emit("dismissed")}}})}
var staticRenderFns = []

export { render, staticRenderFns }